<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="aircraftTypeRatingAudits && aircraftTypeRatingAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="aircraftTypeRatingAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Aircraft Type Rating audits </ng-template>
</ng-template>
